import dewImage from '../../../assets/svg-icons/dewImage.svg';
import Cooperative from '../../../assets/svg-icons/blueCooperative.svg';
import loadBalancer from '../../../assets/svg-icons/blueLoadBalancer.svg';
import arrow from '../../../assets/svg-icons/blueArrow.svg';
import close from '../../../assets/svg-icons/closeBrand.svg';
import closeIcon from '../../../assets/svg-icons/closeBrand.svg';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
// import add from "../../../assets/svg-icons/addGreen.svg";
import securityGroups from '../../../assets/svg-icons/securityGroups.svg';
import {
  useFloatingIPsList,
  useListDews,
  useListLocalImageDetails,
  usePortList,
  useServerList,
  useNetworkList,
  useVolumeList,
  useDBServerList,
  useLoadBalancersList,
  useRouterList,
} from '../layout/resuableEffect';
import { useState } from 'react';
import Modal from '../../../components/modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteUserServer,
  listUserProjects,
  listServers,
  listServer,
  restartUserServer,
  stopUserServer,
  updateFloatingIp,
  allocateProjectFloatingIPs,
  updateResourceSubMode,
} from '../../../hooks/local/userReducer';
import Select from '../../../components/select';
import { formatDateTime } from '../../../hooks/constants';
import Button from '../../../components/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Backdrop, CircularProgress } from '@mui/material';
import { NavLink } from 'react-router-dom';
import usePartnerNavigation from '../../../hooks/usePartnerNavigation';
import { LuScaling } from 'react-icons/lu';
import { useEffect } from 'react';
import AssignedResourceQuotas from './AssignedResourceQuotas';

const Resources = () => {
  document.title = 'Resources - CloudVantage';

  const userServer = useServerList();
  const dispatch = useDispatch();
  const { generatePartnerUrl } = usePartnerNavigation();

  const selectedProject = useSelector((state) => state.user.selectedProject);
  const projectId = selectedProject?.id || null;

  // If we got here without a selected project (e.g. projects fetch forbidden),
  // try to fetch projects once so the app can recover gracefully.
  useEffect(() => {
    if (!projectId) {
      dispatch(listUserProjects());
    }
  }, [dispatch, projectId]);

  // Fetch additional resource types
  const networkList = useNetworkList(projectId);
  const volumeList = useVolumeList(projectId);
  const dbServersList = useDBServerList();
  const loadBalancersList = useLoadBalancersList();
  const routerList = useRouterList(projectId);
  const floatingIPsList = useFloatingIPsList();

  const [managingResource, setManagingResource] = useState(null);
  const [selectedResource, setSelectedResource] = useState(null);
  const [selectedServer, setSelectedServer] = useState(null);
  const [deleteServerModal, setDeleteServerModal] = useState(false);
  const [floatingIPModal, setFloatingIPModal] = useState(false);
  const [isDeassociate, setIsDeassociate] = useState(false);
  const [selectedAssociateFloatingIP, setSelectedAssociateFloatingIP] =
    useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [switchSubscriptionModal, setSwitchSubscriptionModal] = useState(false);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [selectedSubscriptionResource, setSelectedSubscriptionResource] =
    useState(null);

  const showManageResourceModal = (data) => {
    setManagingResource(data);
    const serverDetails = {
      serverId: data.id,
      serverName: data.name,
      flavorId: data.flavor?.id,
    };
    sessionStorage.setItem('selectedServer', JSON.stringify(serverDetails));
  };

  const closeManageResourceModal = () => {
    setManagingResource(null);
  };

  const handleServerAction = async (action, serverId, actionType) => {
    if (!projectId) {
      toast.error('No active project selected. Please refresh or sign in again.', {
        theme: 'colored',
      });
      return;
    }
    setLoading(true);
    setLoadingMessage(
      `${actionType.charAt(0).toUpperCase() + actionType.slice(1)} in progress...`,
    );
    const { payload } = await dispatch(action({ projectId, serverId }));
    setLoading(false);

    if (payload.statuscode === '00') {
      toast.success(
        `${actionType.charAt(0).toUpperCase() + actionType.slice(1)} successful`,
        {
          theme: 'colored',
        },
      );
      await dispatch(listServers(projectId));
      window.location.reload();
    } else {
      toast.error(
        payload.message ||
          `${actionType.charAt(0).toUpperCase() + actionType.slice(1)} failed`,
        {
          theme: 'colored',
        },
      );
    }
  };

  const deleteServer = (serverId) =>
    handleServerAction(deleteUserServer, serverId, 'delete');
  const restartServer = (serverId) =>
    handleServerAction(restartUserServer, serverId, 'restart');
  const stopServer = (serverId) =>
    handleServerAction(stopUserServer, serverId, 'stop');

  const [searchText, setSearchText] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all-dews');

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: 'all-dews', label: 'All dews' },
    { value: 'volumes', label: 'Volumes' },
    { value: 'networks', label: 'Networks' },
    { value: 'databases', label: 'Databases' },
    { value: 'load-balancers', label: 'Load Balancers' },
    { value: 'routers', label: 'Routers' },
    { value: 'floating-ips', label: 'Floating IPs' },
  ];

  const userServerList = Array.isArray(userServer)
    ? userServer
        ?.filter((server) => {
          return (
            server?.addresses &&
            Object.values(server?.addresses).some(
              (addressList) => addressList.length > 0,
            )
          );
        })
        .map((server) => {
          // rest of your existing mapping code
          const externalAddress = server.addresses?.External?.[0]?.addr;
          const allAddresses = Object.values(server.addresses)
            .flat()
            .map((address) => address.addr)
            .join(', ');

          return {
            name: server.name.replace(/_/g, ' '),
            address: externalAddress || allAddresses || '',
            status: server.status === 'ACTIVE' ? 'Active' : 'Inactive',
            id: server?.id,
            flavor: server?.flavor,
            image: server?.image,
            keyPair: server?.key_name || null,
            securityGroups: server?.security_groups,
            date: server?.created,
          };
        })
    : [];

  // Transform network data
  const networkListMap = Array.isArray(networkList)
    ? networkList.map((network) => ({
        name:
          network.name && network.name.trim() !== ''
            ? network.name
            : 'Default Network',
        address: 'N/A', // Networks don't have addresses like servers
        status: network.status === 'ACTIVE' ? 'Active' : 'Inactive',
        id: network?.id,
        type: network.type || 'network',
        date: network?.created_at,
      }))
    : [];

  // Transform volume data
  const volumeListMap = Array.isArray(volumeList)
    ? volumeList.map((volume) => ({
        name:
          volume.name && volume.name.trim() !== ''
            ? volume.name
            : 'Default Volume',
        address: volume.size ? `${volume.size} GB` : 'N/A',
        status: volume.status === 'available' ? 'Active' : 'Inactive',
        id: volume?.id,
        type: 'volume',
        date: volume?.created_at,
      }))
    : [];

  // Transform database data
  const dbServersListMap = Array.isArray(dbServersList)
    ? dbServersList.map((db) => ({
        name: db?.name || 'N/A',
        address: 'Database Server',
        status: db?.status === 'ACTIVE' ? 'Active' : 'Inactive',
        id: db?.id,
        type: 'database',
        date: db?.created,
      }))
    : [];

  // Transform load balancer data
  const loadBalancersListMap = Array.isArray(loadBalancersList)
    ? loadBalancersList.map((lb) => ({
        name: lb?.name || 'N/A',
        address: lb?.vip_address || 'N/A',
        status: lb?.operating_status === 'ONLINE' ? 'Active' : 'Inactive',
        id: lb?.id,
        type: 'load-balancer',
        date: lb?.created_at,
      }))
    : [];

  // Transform router data
  const routerListMap = Array.isArray(routerList)
    ? routerList.map((router) => ({
        name:
          router?.name && router.name.trim() !== ''
            ? router.name
            : 'Default Router',
        address:
          router?.external_gateway_info?.external_fixed_ips?.[0]?.ip_address ||
          'N/A',
        status: router?.status === 'ACTIVE' ? 'Active' : 'Inactive',
        id: router?.id,
        type: 'router',
        date: router?.created_at,
      }))
    : [];

  // Transform floating IP data
  const floatingIPsListMap = Array.isArray(floatingIPsList)
    ? floatingIPsList.map((fip) => ({
        name: fip?.floating_ip_address || 'N/A',
        address: fip?.fixed_ip_address || 'Unassigned',
        status: fip?.status === 'ACTIVE' ? 'Active' : 'Inactive',
        id: fip?.id,
        type: 'floating-ip',
        date: fip?.created_at,
      }))
    : [];

  const hasFloatingIP = (server) => {
    if (!server || !server.addresses) return false;
    return Object.values(server.addresses).some((addressList) =>
      addressList.some((address) => address['OS-EXT-IPS:type'] === 'floating'),
    );
  };

  // Helper function to get the port for a server based on network name and fixed IP
  const getServerPort = (server, portList) => {
    const serverData = userServer.find((s) => s.id === server.id);
    if (!serverData || !serverData.addresses) return null;

    // Find the network name and fixed IP
    let fixedIP = null;
    for (const [, addresses] of Object.entries(serverData.addresses)) {
      const fixed = addresses.find(
        (addr) => addr['OS-EXT-IPS:type'] === 'fixed',
      );
      if (fixed) {
        fixedIP = fixed.addr;
        break;
      }
    }

    // Find the matching port
    const matchingPort = portList.find(
      (port) =>
        port.fixed_ips.some((ip) => ip.ip_address === fixedIP) &&
        port.device_name === server.name,
    );

    return matchingPort
      ? {
          value: matchingPort.id,
          label: `${server.name}: ${fixedIP}`,
        }
      : null;
  };

  // Update the toggleFloatingIPModal to set the portId
  const toggleFloatingIPModal = (server) => {
    setFloatingIPModal(!floatingIPModal);
    setSelectedAssociateFloatingIP(server);
    setIsDeassociate(false);

    // Auto-select the port
    const matchingPort = getServerPort(server, portList);
    if (matchingPort) {
      manageFloatingIP.setFieldValue('portId', matchingPort.value);
    }

    // Reset ipAddress when opening associate modal
    manageFloatingIP.setFieldValue('ipAddress', '');
  };

  const toggleDeassociateFloatingIPModal = (server) => {
    setIsDeassociate(!isDeassociate);
    setFloatingIPModal(!floatingIPModal);
    setSelectedAssociateFloatingIP(server);

    // Find the floating IP associated with the server
    const serverData = userServer.find((s) => s.id === server.id);
    if (serverData && serverData.addresses) {
      const floatingIP = Object.values(serverData.addresses)
        .flat()
        .find((addr) => addr['OS-EXT-IPS:type'] === 'floating');

      if (floatingIP) {
        // Find the corresponding floating IP ID from floatingIPList
        const floatingIPData = floatingIPList.find(
          (ip) => ip.floating_ip_address === floatingIP.addr,
        );
        if (floatingIPData) {
          manageFloatingIP.setFieldValue('ipAddress', floatingIPData.id);
        } else {
          manageFloatingIP.setFieldValue('ipAddress', '');
        }
      } else {
        manageFloatingIP.setFieldValue('ipAddress', '');
      }
    } else {
      manageFloatingIP.setFieldValue('ipAddress', '');
    }
  };

  useListDews();
  useListLocalImageDetails();

  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 5;

  // Handle filter change
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    setCurrentPage(1);
  };

  // Get filtered data based on selected filter
  const getFilteredData = () => {
    switch (selectedFilter) {
      case 'all-dews':
        return (
          userServerList?.map((server) => ({ ...server, type: 'server' })) || []
        );
      case 'volumes':
        return volumeListMap;
      case 'networks':
        return networkListMap;
      case 'databases':
        return dbServersListMap;
      case 'load-balancers':
        return loadBalancersListMap;
      case 'routers':
        return routerListMap;
      case 'floating-ips':
        return floatingIPsListMap;
      default:
        return (
          userServerList?.map((server) => ({ ...server, type: 'server' })) || []
        );
    }
  };

  const filteredData = getFilteredData()?.filter(
    (row) =>
      row?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      row?.status?.toLowerCase().includes(searchText.toLowerCase()),
  );

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry,
  );
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleGetServer = async (server) => {
    setSelectedResource(server);

    const serverId = server?.id;
    if (!projectId) return;

    const { payload } = await dispatch(listServer({ projectId, serverId }));
    setSelectedServer(payload);
  };

  const floatingIPList = useFloatingIPsList();

  const floatingIPsOptions = Array.isArray(floatingIPList)
    ? [
        { label: 'Select a floating ip', value: '' },
        ...floatingIPList.map((port) => ({
          value: port.id,
          label: port.floating_ip_address,
        })),
      ]
    : [{ label: 'Select a floating ip', value: '' }];

  const params = `?device_owner=compute:nova`;
  const portList = usePortList(projectId, params);

  const portOptions = Array.isArray(portList)
    ? [
        { label: 'Select a port', value: '' },
        ...portList.map((port) => ({
          value: port.id,
          label: `${port.device_name}:${port.fixed_ips[0].ip_address}`,
        })),
      ]
    : [{ label: 'Select a port', value: '' }];

  // Function to handle allocating a new floating IP
  const handleAllocateIP = async () => {
    if (!projectId) return;

    const floatingIPsData = {
      description: 'Test Desc',
      projectId,
    };

    const { payload } = await dispatch(
      allocateProjectFloatingIPs(floatingIPsData),
    );
    if (payload.statuscode === '00') {
      window.location.reload();
    }
  };

  const manageFloatingIP = useFormik({
    initialValues: {
      ipAddress: '',
      portId: '',
      description: '',
    },
    validationSchema: Yup.object({
      ipAddress: Yup.string().required('IP address is required'),
      portId: isDeassociate
        ? Yup.string().optional()
        : Yup.string().required('Port is required'),
    }),
    onSubmit: async (values) => {
      const { ipAddress, portId } = values;
      if (!projectId) return;

      let floatingIpData;
      if (isDeassociate) {
        floatingIpData = {
          projectId,
          floatingIpId: ipAddress,
        };
      } else {
        floatingIpData = {
          projectId,
          floatingIpId: ipAddress,
          port_id: portId,
        };
      }

      const { payload } = await dispatch(updateFloatingIp(floatingIpData));
      if (payload.statuscode === '00') {
        toast.success(
          `Floating IP ${isDeassociate ? 'disassociated' : 'associated'} successfully`,
          {
            theme: 'colored',
          },
        );
        window.location.reload();
      } else {
        toast.error(
          payload.message ||
            `Failed to ${isDeassociate ? 'disassociate' : 'associate'} floating IP`,
          {
            theme: 'colored',
          },
        );
      }
    },
  });

  const manageSwitchSubscription = useFormik({
    initialValues: {
      payment_mode: '',
    },
    validationSchema: Yup.object({
      payment_mode: Yup.string().required('Payment mode is required'),
    }),
    onSubmit: async (values) => {
      setSubscriptionLoading(true);
      setLoading(true);
      setLoadingMessage('Updating subscription mode...');
      const resourceId = selectedSubscriptionResource.id;
      const subModeData = {
        payment_mode: values.payment_mode,
      };

      const { payload } = await dispatch(
        updateResourceSubMode({ resourceId, subModeData }),
      );
      setSubscriptionLoading(false);
      setLoading(false);
      if (payload.statuscode === '00') {
        toast.success('Subscription mode updated successfully', {
          theme: 'colored',
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(payload.message || 'Failed to update subscription mode', {
          theme: 'colored',
        });
      }
    },
  });

  // Helper function to get all associated floating IPs
  const getAssociatedFloatingIPs = () => {
    const associatedIPs = new Set();
    userServer.forEach((server) => {
      if (server.addresses) {
        Object.values(server.addresses).forEach((addressList) => {
          addressList.forEach((addr) => {
            if (addr['OS-EXT-IPS:type'] === 'floating') {
              associatedIPs.add(addr.addr);
            }
          });
        });
      }
    });
    return associatedIPs;
  };

  return (
    <div>
      <AssignedResourceQuotas />
      <div className="grid gap-2 mb-10">
        <p className="dark:text-white text-sm">Resources:</p>
        {!projectId ? (
          <div className="bg-white dark:bg-slate-800 rounded-md border dark:border-[#c4c4c432] p-6">
            <p className="text-sm dark:text-white font-medium mb-1">
              Project not available
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              We couldn’t load your projects, so resource data can’t be shown yet.
              This can happen when the backend returns a 403 for the projects endpoint.
            </p>
            <div className="mt-4 flex gap-3">
              <button
                type="button"
                onClick={() => dispatch(listUserProjects())}
                className="text-white text-xs px-4 py-3 rounded bg-primaryBlue"
              >
                Retry loading projects
              </button>
              <Link to={generatePartnerUrl('/sign-out')}>
                <button
                  type="button"
                  className="text-primaryBlue text-xs px-4 py-3 rounded border border-primaryBlue"
                >
                  Sign out
                </button>
              </Link>
            </div>
          </div>
        ) : (
          ((userServer && userServer.length > 0) ||
          (volumeList && volumeList.length > 0) ||
          (networkList && networkList.length > 0) ||
          (dbServersList && dbServersList.length > 0) ||
          (loadBalancersList && loadBalancersList.length > 0) ||
          (routerList && routerList.length > 0) ||
          (floatingIPsList && floatingIPsList.length > 0)) ? (
          <div className="dark:text-white">
            <div className="bg-white dark:bg-slate-800 px-3 md:px-4 border dark:border-[#c4c4c432] border-b rounded-t-md text-sm flex justify-between items-center">
              <div className="">
                {selectedFilter === 'all-dews' &&
                  `Active servers (Dews) - [${userServerList?.length || 0}]`}
                {selectedFilter === 'volumes' &&
                  `Volumes - [${volumeListMap?.length || 0}]`}
                {selectedFilter === 'networks' &&
                  `Networks - [${networkListMap?.length || 0}]`}
                {selectedFilter === 'databases' &&
                  `Databases - [${dbServersListMap?.length || 0}]`}
                {selectedFilter === 'load-balancers' &&
                  `Load Balancers - [${loadBalancersListMap?.length || 0}]`}
                {selectedFilter === 'routers' &&
                  `Routers - [${routerListMap?.length || 0}]`}
                {selectedFilter === 'floating-ips' &&
                  `Floating IPs - [${floatingIPsListMap?.length || 0}]`}
              </div>
              {selectedFilter === 'all-dews' && (
                <Link
                  to={generatePartnerUrl('/client-area/vps')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create dew</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
              {selectedFilter === 'volumes' && (
                <Link
                  to={generatePartnerUrl('/client-area/volumes')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create volume</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
              {selectedFilter === 'networks' && (
                <Link
                  to={generatePartnerUrl('/networks')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create network</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
              {selectedFilter === 'databases' && (
                <Link
                  to={generatePartnerUrl('/managedDatabases')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create database</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
              {selectedFilter === 'load-balancers' && (
                <Link
                  to={generatePartnerUrl('/manageLoadBalancers')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create load balancer</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
              {selectedFilter === 'routers' && (
                <Link
                  to={generatePartnerUrl('/routers')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create router</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
              {selectedFilter === 'floating-ips' && (
                <Link
                  to={generatePartnerUrl('/floatingIPS')}
                  className="cursor-pointer py-4 px-3 flex items-center gap-1"
                >
                  <div className="text-primaryBlue">Create floating IP</div>
                  <div>
                    <img src={arrow} alt="" className="h-5" />
                  </div>
                </Link>
              )}
            </div>

            <div className="my-6 bg-white p-4 rounded-md">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end mb-4">
                <div className="md:col-span-3">
                  <Select
                    label="Filter Resources"
                    name="resources"
                    options={options}
                    value={selectedFilter}
                    onChange={handleFilterChange}
                  />
                </div>
                <div className="md:col-span-4">
                  <input
                    type="search"
                    name=""
                    value={searchText}
                    onChange={handleSearchChange}
                    placeholder="Search by name or status..."
                    className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                  />
                </div>
              </div>

              <div className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                {currentEntries.length > 0 ? (
                  currentEntries.map((val, key) => (
                    <div
                      key={key}
                      className="grid grid-cols-3 md:grid-cols-5 justify-between items-center gap-1 md:gap-2 py-4 last:border-none border-b dark:border-b-[#c4c4c432]"
                    >
                      <div
                        className="col-span-3 md:col-span-2 text-primaryBlue capitalize hover:underline cursor-pointer "
                        onClick={() => {
                          if (
                            val.type === 'server' ||
                            selectedFilter === 'all-dews'
                          ) {
                            handleGetServer(val);
                          }
                        }}
                      >
                        {val.name}
                      </div>
                      <div className="md:col-span-1 text-[13px]">
                        {val.address}
                      </div>
                      <div className="md:col-span-1 text-[13px]">
                        {val.status === 'Active' ? (
                          <div className="flex gap-1 items-center text-emerald-600">
                            <span className="size-2 rounded-full bg-emerald-500 animate-pulse"></span>
                            <span>Active</span>
                          </div>
                        ) : (
                          <div className="flex gap-1 items-center text-red-600">
                            <span className="size-2 rounded-full bg-red-500"></span>
                            <span>Inactive</span>
                          </div>
                        )}
                      </div>
                      <div className="flex justify-around items-center pe-4 md:col-span-1">
                        {(val.type === 'server' ||
                          selectedFilter === 'all-dews') && (
                          <>
                            <NavLink
                              className="bg-primaryBlue text-white py-2 px-3 rounded-md"
                              to={{
                                pathname: `/resources/${projectId}/servers/${val.id}`,
                              }}
                            >
                              Show Metrics
                            </NavLink>
                            <span
                              onClick={() => showManageResourceModal(val)}
                              className="px-3 py-2 text-xs dark:text-white cursor-pointer border border-[#c4c4c450] dark:border-[#c4c4c416] rounded hover:bg-primaryBlue/10 hover:border-[#c4c4c405]"
                            >
                              Manage
                            </span>
                          </>
                        )}
                        {val.type === 'network' && (
                          <NavLink
                            className="px-3 py-2 text-xs border border-primaryBlue rounded text-primaryBlue hover:bg-primaryBlue/10"
                            to="/networks"
                          >
                            Manage Network
                          </NavLink>
                        )}
                        {val.type === 'volume' && (
                          <NavLink
                            className="px-3 py-2 text-xs border border-primaryBlue rounded text-primaryBlue hover:bg-primaryBlue/10"
                            to="/client-area/volumes"
                          >
                            Manage Volume
                          </NavLink>
                        )}
                        {val.type === 'database' && (
                          <NavLink
                            className="px-3 py-2 text-xs border border-primaryBlue rounded text-primaryBlue hover:bg-primaryBlue/10"
                            to="/managedDatabases"
                          >
                            Manage Database
                          </NavLink>
                        )}
                        {val.type === 'load-balancer' && (
                          <NavLink
                            className="px-3 py-2 text-xs border border-primaryBlue rounded text-primaryBlue hover:bg-primaryBlue/10"
                            to="/manageLoadBalancers"
                          >
                            Manage Load Balancer
                          </NavLink>
                        )}
                        {val.type === 'router' && (
                          <NavLink
                            className="px-3 py-2 text-xs border border-primaryBlue rounded text-primaryBlue hover:bg-primaryBlue/10"
                            to="/routers"
                          >
                            Manage Router
                          </NavLink>
                        )}
                        {val.type === 'floating-ip' && (
                          <NavLink
                            className="px-3 py-2 text-xs border border-primaryBlue rounded text-primaryBlue hover:bg-primaryBlue/10"
                            to="/floatingIPS"
                          >
                            Manage Floating IP
                          </NavLink>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="grid h-[20rem] items-center justify-center">
                    <div className="grid gap-2 items-center justify-center">
                      <div className="bg-primaryBlue/10 rounded-full h-16 w-16 mx-auto flex items-center justify-center">
                        <img src={dewImage} alt="" className="h-8" />
                      </div>
                      <div className="text-center font-medium">
                        No resource found
                      </div>
                      <p className="text-slate-400 text-xs">
                        Resources will show here when you create them
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {totalPages > 1 && (
                <div className="flex justify-between items-center mt-6 px-4">
                  <div className="text-xs text-gray-500">
                    Showing {indexOfFirstEntry + 1} to{' '}
                    {Math.min(indexOfLastEntry, filteredData.length)} of{' '}
                    {filteredData.length} entries
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                      className={`px-3 py-1 text-xs border rounded ${
                        currentPage === 1
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-white text-primaryBlue hover:bg-primaryBlue/5'
                      }`}
                    >
                      Previous
                    </button>
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                      className={`px-3 py-1 text-xs border rounded ${
                        currentPage === totalPages
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-white text-primaryBlue hover:bg-primaryBlue/5'
                      }`}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className=" flex justify-between items-center">
            <p className="text-gray-500 text-xl">
              You don't have any resources yet
            </p>
            <Link to={generatePartnerUrl('/client-area/vps')}>
              <button className="text-white p-3 text-xs rounded bg-primaryBlue ">
                Create Server (Dews)
              </button>
            </Link>
          </div>
        ))}


        {/* Manage Resource Modal */}
        {managingResource && (
          <div className="w-full fixed h-screen bg-black/30 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
            <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
              <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                <div className="flex gap-2 items-center">
                  <span className="dark:text-white">
                    Manage "{managingResource.name}"
                  </span>
                </div>
                <img
                  src={close}
                  onClick={closeManageResourceModal}
                  className="h-5 cursor-pointer"
                  alt=""
                />
              </div>
              <div className="p-4 grid gap-1">
                <Link
                  to={generatePartnerUrl('/client-area/snapshot')}
                  className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                >
                  <span>Create snapshot</span>
                  <span>
                    <img src={arrow} alt="" className="" />
                  </span>
                </Link>
                <Link
                  to={generatePartnerUrl('/securityGroups')}
                  className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                >
                  <span>Manage security group</span>
                  <span>
                    <img src={arrow} alt="" className="" />
                  </span>
                </Link>

                <Link
                  to={generatePartnerUrl('/resizeInstance')}
                  className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                >
                  <span>Resize Instance</span>
                  <span>
                    <img src={arrow} alt="" className="" />
                  </span>
                </Link>
                <div className="grid gap-1">
                  {hasFloatingIP(
                    userServer.find((s) => s.id === managingResource.id),
                  ) ? (
                    <div
                      className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                      onClick={() =>
                        toggleDeassociateFloatingIPModal(managingResource)
                      }
                    >
                      <span>Disassociate Floating IP</span>
                      <span>
                        <img src={arrow} alt="" className="" />
                      </span>
                    </div>
                  ) : (
                    <div
                      className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                      onClick={() => toggleFloatingIPModal(managingResource)}
                    >
                      <span>Associate Floating IP</span>
                      <span>
                        <img src={arrow} alt="" className="" />
                      </span>
                    </div>
                  )}
                </div>
                <div
                  className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                  onClick={() => {
                    setSwitchSubscriptionModal(true);
                    setSelectedSubscriptionResource(managingResource);
                    closeManageResourceModal();
                  }}
                >
                  <span>Switch Server Subscription</span>
                  <span>
                    <img src={arrow} alt="" className="" />
                  </span>
                </div>

                <div className="grid gap-1">
                  {managingResource.status.toUpperCase() === 'ACTIVE' ? (
                    <div
                      className="rounded-md bg-red-500/10 py-5 px-3 text-xs cursor-pointer text-red-500 text-center"
                      onClick={() => stopServer(managingResource.id)}
                    >
                      Shutdown server
                    </div>
                  ) : (
                    <div
                      className="rounded-md bg-primaryBlue/10 hover:bg-primaryBlue/20 transition-colors py-5 px-3 text-xs cursor-pointer text-primaryBlue text-center"
                      onClick={() => restartServer(managingResource.id)}
                    >
                      Restart server
                    </div>
                  )}

                  <div
                    className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                    onClick={() => {
                      setDeleteServerModal(true);
                    }}
                  >
                    <span className="hover:underline">Delete server</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Server Modal */}
        <Modal
          title={'Delete Server'}
          isVisible={deleteServerModal}
          onClose={() => setDeleteServerModal(false)}
        >
          <div className="text-sm text-center pt-6">
            Are you sure you want to delete{' '}
            <span className="underline">{managingResource?.name}</span> . This
            action cannot be undone.
          </div>
          <div className="grid gap-4 justify-center py-6">
            <button
              className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
              onClick={() => deleteServer(managingResource?.id)}
            >
              Yes, delete {managingResource?.name}
            </button>
            <button
              className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
              onClick={() => setDeleteServerModal(false)}
            >
              Cancel
            </button>
          </div>
        </Modal>

        {/* Switch Subscription Modal */}
        <Modal
          title={'Switch Server Subscription'}
          isVisible={switchSubscriptionModal}
          onClose={() => {
            setSwitchSubscriptionModal(false);
            setSelectedSubscriptionResource(null);
          }}
        >
          <div className="p-6">
            <Select
              label="Subscription Payment Mode"
              options={[
                {
                  label: 'Select a payment mode',
                  value: '',
                },
                { label: 'Monthly', value: 'monthly' },
                { label: 'Yearly', value: 'yearly' },
              ]}
              value={manageSwitchSubscription.values.payment_mode}
              onChange={(e) =>
                manageSwitchSubscription.setFieldValue(
                  'payment_mode',
                  e.target.value,
                )
              }
            />
            {manageSwitchSubscription.touched.payment_mode &&
              manageSwitchSubscription.errors.payment_mode && (
                <div className="text-red-500 text-xs mt-1">
                  {manageSwitchSubscription.errors.payment_mode}
                </div>
              )}
            <div className="mt-6 flex justify-center">
              <Button
                handleClick={manageSwitchSubscription.handleSubmit}
                loading={subscriptionLoading}
                buttonText="Submit"
                buttonRole="submit"
              />
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid gap-4 mb-10">
        <p className="dark:text-white text-sm">Create:</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to={generatePartnerUrl('/client-area/vps')}
            className="flex gap-4 items-center w-fit"
          >
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center">
              <img src={dewImage} alt="" className="h-5" />
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Create Servers (Dew)</p>
              <p className="text-gray-400 text-[13px]">
                Create a new Virtual Private Server (VPS)
              </p>
            </div>
          </Link>
          <Link
            to={generatePartnerUrl('/securityGroups')}
            className="flex gap-4 items-center w-fit"
          >
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center">
              <img src={securityGroups} alt="" className="h-5" />
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Security groups</p>
              <p className="text-gray-400 text-[13px]">
                Manage your security groups
              </p>
            </div>
          </Link>

          <Link
            to={generatePartnerUrl('/client-area/volumes')}
            className="flex gap-4 items-center w-fit"
          >
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center">
              <img src={Cooperative} alt="" className="h-5" />
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Manage Volumes</p>
              <p className="text-gray-400 text-[13px]">Manage your volumes</p>
            </div>
          </Link>

          <Link
            to={generatePartnerUrl('/manageLoadBalancers')}
            className="flex gap-4 items-center w-fit"
          >
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center">
              <img src={loadBalancer} alt="" className="h-5" />
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Create a Load Balancer</p>
              <p className="text-gray-400 text-[13px]">
                Distribute traffic between multiple dews
              </p>
            </div>
          </Link>

          <Link
            to={generatePartnerUrl('/managedDatabases')}
            className="flex gap-4 items-center w-fit"
          >
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center text-primaryBlue">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-database-icon lucide-database"
              >
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M3 5V19A9 3 0 0 0 21 19V5" />
                <path d="M3 12A9 3 0 0 0 21 12" />
              </svg>
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Managed Databases </p>
              <p className="text-gray-400 text-[13px]">
                Deploy managed databases
              </p>
            </div>
          </Link>
          <NavLink
            className="flex gap-4 items-center w-fit"
            to={{
              pathname: `/resources/${projectId}/bucket-storages`,
            }}
          >
            {' '}
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center text-primaryBlue">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-database-icon lucide-database"
              >
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M3 5V19A9 3 0 0 0 21 19V5" />
                <path d="M3 12A9 3 0 0 0 21 12" />
              </svg>
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Manage Object Storages </p>
              <p className="text-gray-400 text-[13px]">
                Create and manage object storages
              </p>
            </div>
          </NavLink>
          <NavLink
            className="flex gap-4 items-center w-fit"
            to={{
              pathname: `/resources/${projectId}/auto-scaling`,
            }}
          >
            {' '}
            <div className="bg-brandBlue dark:bg-brandBlue/10 rounded-md w-20 h-16 flex items-center justify-center text-primaryBlue">
              <LuScaling />
            </div>
            <div className="dark:text-white text-sm">
              <p className="">Auto Scaling </p>
              <p className="text-gray-400 text-[13px]">
                Create and manage stacks
              </p>
            </div>
          </NavLink>
        </div>
      </div>

      {selectedResource && (
        <div className="fixed w-full bg-black/30 top-0 left-0 z-50 h-screen">
          <div className="w-full flex h-full items-center justify-center p-4">
            <div className="bg-white dark:bg-[#141D26] dark:text-white w-full md:w-[80%] rounded h-full overflow-y-auto">
              <div className="px-6 md:px-10 py-6 border-b dark:border-b-[#c4c4c432] flex justify-between items-center">
                <span className="text-primaryBlue font-medium">
                  Basic Instance Information:
                </span>
                <span
                  onClick={() => setSelectedResource(null)}
                  className="cursor-pointer"
                >
                  <img src={closeIcon} alt="Close" className="h-5" />
                </span>
              </div>

              <div className="py-10 grid gap-8 px-6">
                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black text-lg mb-4 border-b border-gray-400 pb-2">
                    Basic Info:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-2">
                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">Name:</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {selectedServer?.name}
                      </h4>
                    </div>

                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">IP Address:</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {Object.values(selectedServer?.addresses || {})
                          .flat()
                          .map((address) => address.addr)
                          .join(', ') || 'No IP address available'}
                      </h4>
                    </div>

                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">Flavor ID:</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {selectedServer?.flavor?.id}
                      </h4>
                    </div>

                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">Status:</h4>
                      {selectedServer?.status === 'ACTIVE' ? (
                        <div className="flex gap-1 items-center bg-emerald-500  text-white py-2 px-6 rounded-md">
                          <span>Active</span>
                        </div>
                      ) : (
                        <div className="flex gap-1 items-center bg-red-600 text-red-600 py-2 px-6 rounded-md">
                          <span>Error</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black text-lg mb-4 border-b border-gray-400 pb-2">
                    Technical Specifications:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="w-full flex flex-col items-start">
                      <h4 className="text-black text-lg">VCPU</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {selectedServer?.flavor?.vcpus || '0'} vCPUs
                      </h4>
                    </div>

                    <div className="w-full flex flex-col items-start">
                      <h4 className="text-black text-lg">RAM</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {selectedServer?.flavor?.ram || '0'} RAM
                      </h4>
                    </div>

                    <div className="w-full flex flex-col items-start">
                      <h4 className="text-black text-lg">Disk Size</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {selectedServer?.flavor?.disk || '0'} GB Disk Size
                      </h4>
                    </div>

                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">Image or OS:</h4>
                      <h4 className="text-gray-800 font-semibold text-lg">
                        {selectedServer?.image?.name}
                      </h4>
                    </div>

                    {selectedServer?.key_name && (
                      <div className="w-full flex flex-col items-start ">
                        <h4 className="text-black text-lg">Key-Pair Name:</h4>
                        <h4 className="text-gray-800 font-semibold text-xl">
                          {selectedServer?.key_name}
                        </h4>
                      </div>
                    )}

                    <div className="w-full flex flex-col items-start">
                      <h4 className="text-black text-lg">Volumes:</h4>

                      {selectedServer &&
                      selectedServer['os-extended-volumes:volumes_attached']
                        ?.length > 0 ? (
                        <ul className="flex flex-col gap-1">
                          {selectedServer[
                            'os-extended-volumes:volumes_attached'
                          ].map((item, i) => (
                            <li
                              key={i}
                              className="flex gap-2 text-lg items-center text-gray-800"
                            >
                              {i + 1}. {item?.name || item?.id}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="flex flex-col items-center text-gray-800 font-semibold text-xl">
                          No Volumes attached to this instance yet.
                        </div>
                      )}
                    </div>

                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">Security Groups:</h4>
                      {selectedServer?.security_groups?.length > 0 ? (
                        <ul className="flex flex-col gap-1">
                          {selectedServer?.security_groups?.map((item, i) => (
                            <li
                              key={i}
                              className="flex gap-2 text-lg items-center text-gray-800"
                            >
                              {i + 1}. {item?.name}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="flex flex-col items-center">
                          No Security Group attached to this instance yet.
                        </div>
                      )}
                    </div>

                    <div className="w-full flex flex-col items-start ">
                      <h4 className="text-black text-lg">Date of Creation:</h4>
                      <h4 className="text-gray-800 font-semibold text-xl">
                        {formatDateTime(selectedResource?.date)}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Manage Floating IP Associations Modal */}
      {floatingIPModal && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/30 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
            <div className="flex items-center justify-between mb-4">
              <p className="text-lg font-medium">
                Manage{' '}
                {isDeassociate
                  ? 'Disassociate Floating IP'
                  : 'Associate Floating IP'}
              </p>
              <span
                onClick={
                  isDeassociate
                    ? toggleDeassociateFloatingIPModal
                    : toggleFloatingIPModal
                }
                className="cursor-pointer"
              >
                <img alt="" src={close} className="h-5" />
              </span>
            </div>

            <form
              className="gap-y-6 grid"
              onSubmit={manageFloatingIP.handleSubmit}
            >
              <div className="grid gap-2">
                <div className="flex items-center justify-between">
                  <label className="text-sm font-medium">
                    IP Address <span className="text-red-500">*</span>
                  </label>
                  {floatingIPsOptions.length === 1 && !isDeassociate && (
                    <button
                      type="button"
                      onClick={handleAllocateIP}
                      className="text-primaryBlue text-sm flex items-center gap-1 underline"
                    >
                      <span className="text-lg">+</span> Allocate IP
                    </button>
                  )}
                </div>
                <p className="text-sm text-gray-500">
                  {isDeassociate
                    ? 'Select the floating IP address to disassociate.'
                    : 'Select the IP address you wish to associate with the selected instance or port.'}
                </p>
                <Select
                  name="ipAddress"
                  options={
                    isDeassociate
                      ? floatingIPsOptions.filter(
                          (option) =>
                            userServer.find(
                              (s) => s.id === selectedAssociateFloatingIP.id,
                            )?.addresses &&
                            Object.values(
                              userServer.find(
                                (s) => s.id === selectedAssociateFloatingIP.id,
                              ).addresses,
                            )
                              .flat()
                              .some(
                                (addr) =>
                                  addr.addr === option.label &&
                                  addr['OS-EXT-IPS:type'] === 'floating',
                              ),
                        )
                      : floatingIPsOptions.filter(
                          (option) =>
                            !getAssociatedFloatingIPs().has(option.label),
                        )
                  }
                  value={manageFloatingIP.values.ipAddress}
                  onBlur={manageFloatingIP.handleBlur}
                  onChange={(e) =>
                    manageFloatingIP.setFieldValue('ipAddress', e.target.value)
                  }
                  onError={
                    manageFloatingIP.errors.ipAddress &&
                    manageFloatingIP.touched.ipAddress
                      ? manageFloatingIP.errors.ipAddress
                      : null
                  }
                />
              </div>

              {!isDeassociate && (
                <div className="grid gap-2">
                  <label className="text-sm font-medium">
                    Port to be associated{' '}
                    <span className="text-red-500">*</span>
                  </label>
                  <Select
                    name="portId"
                    options={portOptions}
                    placeholder="Select a port"
                    value={manageFloatingIP.values.portId}
                    onBlur={manageFloatingIP.handleBlur}
                    onChange={(e) =>
                      manageFloatingIP.setFieldValue('portId', e.target.value)
                    }
                    onError={
                      manageFloatingIP.errors.portId &&
                      manageFloatingIP.touched.portId
                        ? manageFloatingIP.errors.portId
                        : null
                    }
                  />
                </div>
              )}

              <div className="flex justify-end gap-2">
                <button
                  onClick={
                    isDeassociate
                      ? toggleDeassociateFloatingIPModal
                      : toggleFloatingIPModal
                  }
                  className="px-4 py-4 text-xs border-[1.5px] border-primaryBlue rounded-sm text-primaryBlue cursor-pointer text-center"
                >
                  Cancel
                </button>

                <Button
                  buttonText={isDeassociate ? 'De-associate' : 'Associate'}
                  buttonRole={'submit'}
                />
              </div>
            </form>
          </div>
        </div>
      )}

      {loading && (
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
          <p className="ml-3">{loadingMessage}</p>
        </Backdrop>
      )}
    </div>
  );
};

export default Resources;
